// extracted by mini-css-extract-plugin
export default {"flex":"cardWrapper_flex__6Q7+6"};